export default "__VITE_ASSET__fcbee5ec__"